import {
  MARKETING_MATERIAL_TYPE,
  MARKETING_MATERIAL_CUSTOM_DESIGN_TYPES,
} from '../../../../views/AlbumFolder/AlbumFolderMarketing/constants';

/**
 * Returns which marketing material types allow for configuration
 *
 * @param {String} marketingMaterialType Marketing Material type to confirm.
 * @returns {boolean} Whether configuration is required or not.
 */
export const marketingMaterialRequiresConfiguration = marketingMaterialType => {
  return [MARKETING_MATERIAL_TYPE.EVENT_FLYER].includes(marketingMaterialType);
};

/**
 * Returns which marketing material types support a custom uploaded design
 *
 * @param {String} marketingMaterialType Marketing Material type to confirm.
 * @returns {boolean} Whether a custom design is supported or not.
 */
export const marketingMaterialSupportsCustomDesign = marketingMaterialType => {
  return MARKETING_MATERIAL_CUSTOM_DESIGN_TYPES.includes(marketingMaterialType);
};
